import { Box, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const SelectedWrapper = styled(Box)({
  display: "flex",
  height: "100%",
  minHeight: "calc(100vh - 80px)",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",

  "& .jobs-panel": {
    width: "320px",
    minWidth: "320px",
    borderRight: "1px solid #e2e8f0",
    background: "#ffffff",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: "2px 0 10px rgba(0, 0, 0, 0.02)",
  },

  "& .jobs-panel__header": {
    padding: "20px 20px 14px",
    borderBottom: "1px solid #f1f5f9",
  },

  "& .jobs-panel__title": {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: colors.primary,
  },

  "& .jobs-panel__search": {
    padding: "10px 16px",
    borderBottom: "1px solid #f1f5f9",
  },

  "& .jobs-panel__list": {
    flex: 1,
    overflowY: "auto",
    padding: "12px 10px",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: "10px",
    },
  },

  "& .job-card": {
    padding: "14px 16px",
    borderRadius: "12px",
    cursor: "pointer",
    marginBottom: "8px",
    border: "1px solid #f1f5f9",
    borderLeft: "4px solid transparent",
    backgroundColor: "#ffffff",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#cbd5e1",
      transform: "translateX(2px)",
    },
  },

  "& .job-card--active": {
    backgroundColor: colors.primaryLight,
    borderLeftColor: colors.primary,
    borderColor: colors.primaryLightBorder || "#fecdd3",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.03)",
  },

  "& .job-card__id": {
    fontSize: "11px",
    fontWeight: 700,
    color: colors.primary,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },

  "& .job-card__role": {
    fontSize: "15px",
    fontWeight: 700,
    color: "#0f172a",
    lineHeight: 1.35,
    marginTop: "2px",
  },

  "& .job-card__count": {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
    fontWeight: 500,
  },

  "& .candidates-panel": {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    minWidth: 0,
  },

  "& .candidates-panel__header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 28px 16px",
    flexWrap: "wrap",
    gap: "12px",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e2e8f0",
  },

  "& .candidates-panel__title": {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#0f172a",
  },

  "& .candidates-panel__subtitle": {
    fontSize: "13px",
    color: "#64748b",
    marginTop: "2px",
  },

  "& .candidates-panel__actions": {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
  },

  "& .candidates-table-wrapper": {
    flex: 1,
    overflowY: "auto",
    padding: "24px 28px",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: "10px",
    },
  },

  "& .candidates-table": {
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
    border: "1px solid #e2e8f0",
    overflowX: "auto",
    backgroundColor: "#ffffff",
    "&::-webkit-scrollbar": {
      height: "8px",
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f5f9",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#cbd5e1",
      borderRadius: "4px",
      "&:hover": {
        background: colors.primary,
      },
    },
  },

  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
    textAlign: "center",
  },

  "& .MuiTableCell-body": {
    fontSize: "14px",
    color: "#374151",
    padding: "14px 16px",
    borderBottom: "1px solid #f0f0f0",
    textAlign: "center",
  },

  "& .MuiTableRow-root:last-child .MuiTableCell-body": {
    borderBottom: "none",
  },

  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.sidebarHover || "#fef2f2",
    },
  },

  "& .table_user-primary-detail": {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-start",
    "& > div > p": {
      fontSize: "0.875rem",
      "&:nth-of-type(2)": {
        color: "#919eab",
      },
    },
  },

  "& .candidate-name": {
    fontWeight: 600,
    color: "#1a1a1a",
    fontSize: "14px",
    textAlign: "left",
  },

  "& .candidate-avatar": {
    width: 36,
    height: 36,
    borderRadius: "50%",
    backgroundColor: colors.primaryLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "14px",
    color: colors.primary,
    flexShrink: 0,
    border: `1px solid ${colors.primaryLightBorder}`,
  },

  "& .score-chip": {
    fontWeight: 700,
    fontSize: "13px",
    borderRadius: "8px",
    minWidth: "48px",
    height: "28px",
  },

  "& .schedule-btn": {
    textTransform: "none",
    borderRadius: "8px",
    padding: "6px 14px",
    fontWeight: 600,
    fontSize: "12px",
    backgroundColor: colors.primary,
    color: "#ffffff",
    whiteSpace: "nowrap",
    boxShadow: "0 2px 6px rgba(127, 29, 29, 0.2)",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: "0 4px 12px rgba(127, 29, 29, 0.3)",
    },
  },

  "& .shortlist-btn": {
    textTransform: "none",
    borderRadius: "10px",
    padding: "8px 20px",
    fontWeight: 600,
    fontSize: "13px",
    backgroundColor: colors.primary,
    color: "#ffffff",
    boxShadow: "0 4px 14px rgba(127, 29, 29, 0.25)",
    "&:hover": {
      backgroundColor: colors.primaryHover,
    },
  },

  "& .row--shortlisted .MuiTableCell-body": {
    backgroundColor: "#f0fdf4",
  },

  "& .row--shortlisted:hover .MuiTableCell-body": {
    backgroundColor: "#ecfdf5 !important",
  },

  "& .shortlisted-chip": {
    backgroundColor: "#dcfce7",
    color: "#15803d",
    fontWeight: 700,
    fontSize: "12px",
    border: "1px solid #86efac",
    height: "28px",
  },

  "& .pagination-bar": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 28px 24px",
    marginTop: "0",
    flexWrap: "wrap",
    gap: "12px",
  },

  "& .pagination-info": {
    fontSize: "13px",
    color: "#64748b",
    fontWeight: 500,
  },

  "& .pagination-buttons": {
    display: "flex",
    gap: "8px",
  },

  "& .pagination-btn": {
    backgroundColor: colors.primary,
    color: "#ffffff",
    textTransform: "none",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "13px",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: colors.primaryHover,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.buttonDisabled.background,
      color: colors.buttonDisabled.color,
      opacity: 1,
      cursor: "not-allowed",
    },
  },

  "& .empty-state": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "400px",
    color: "#94a3b8",
  },

  "& .empty-state__text": {
    fontSize: "16px",
    fontWeight: 600,
    color: "#64748b",
    marginTop: "12px",
  },

  "@media (max-width: 900px)": {
    flexDirection: "column",

    "& .jobs-panel": {
      width: "100%",
      minWidth: "100%",
      maxHeight: "240px",
      borderRight: "none",
      borderBottom: "1px solid #e2e8f0",
    },
  },
});
